<template lang="pug">
  .dropdown-menu
    .dropdown-menu__item
      .dropdown-menu__link(
      v-html="calcReason(request.comment)"
      )
</template>
<script>
export default {
  name: "ReasonForCancellation",
  props: ["request"],
  methods: {
    calcReason(str) {
      var obj = JSON.parse(str);
      if (obj.reject_type === "0") {
        return "Недействительные документы:<br>" + obj.comment;
      } else if (obj.reject_type === "1") {
        var awards = this.request.awards;
        var awardsNames = [];
        var message = "";
        for (var i = 0; i < awards.length; i++) {
          if (!awards[i].is_approved) {
            awardsNames.push(
              " " + awards[i].name + " (" + awards[i].points + ")"
            );
          }
        }
        if (awardsNames.length > 1) {
          message =
            "<br>Грамоты" +
            ":" +
            awardsNames.toString() +
            " — не одобрены оператором.";
        } else if (awardsNames.length === 1) {
          message =
            "<br>Грамота" +
            ":" +
            awardsNames.toString() +
            " — не одобрена оператором.";
        }
        return "Не прошла по рейтингу." + message;
      } else {
        return obj.comment;
      }
    },
    onBodyClick() {
      this.$emit("close");
    }
  },
  created() {
    document.body.addEventListener("click", this.onBodyClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.onBodyClick);
  }
};
</script>
